let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1QYxo")).then(() => parcelRequire('7Cp6N'));